import { render } from "./AutomationLandingCard.vue?vue&type=template&id=c05e1e1e&scoped=true"
import script from "./AutomationLandingCard.vue?vue&type=script&lang=js"
export * from "./AutomationLandingCard.vue?vue&type=script&lang=js"

import "./AutomationLandingCard.vue?vue&type=style&index=0&id=c05e1e1e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05e1e1e"]])

export default __exports__